<template>
    <div style="display:flex;">
        <!-- <el-select style="margin:16px 0 0 10px" v-model="searchValue" filterable clearable placeholder="搜索条件" @change="onChange">
            <template #prefix><i class="el-icon-search"></i></template>
            <el-option v-for="item in files" :key="item.file_id" :label="item.caption" :value="item.name"></el-option>
        </el-select> -->

        <!-- <el-menu style="margin-left:auto;" mode="horizontal"
            background-color="#545c64" text-color="#fff" active-text-color="#fff" @select="onMenuSelect">
            <el-menu-item class="tw-tablet-menu-item" index="user">
                <i class="el-icon-user-solid"></i>
                <template #title><span>用户管理</span></template>
            </el-menu-item>
        </el-menu> -->
    </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import userService from '../../services/user.service'

export default {
    name: 'tw-tablet-list-toolbar',
    setup() {
        const router = useRouter()
        const searchValue = ref([])
        const files = ref([])

        userService.routes.forEach(el => {
            files.value.push({
                file_id: el.file_id,
                name: el.name,
                caption: el.caption
            })
        })

        const onChange = function(value) {
            router.push({ name: value })
        }

        // const onMenuSelect = function(key) {
        //     switch (key) {
        //         case 'user':
        //             router.push({ name: 'user' })
        //             break;
        //         default:
        //             break;
        //     }
        // }

        return {
            searchValue,
            files,
            onChange,
            // onMenuSelect
        }
    }
}
</script>

<style>

</style>